import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export function notificationReducer(state, action) {
  var _a;
  var chainId = action.chainId;
  var chainState = (_a = state[chainId]) !== null && _a !== void 0 ? _a : [];
  switch (action.type) {
    case 'ADD_NOTIFICATION':
      return Object.assign(Object.assign({}, state), _defineProperty({}, chainId, [action.notification].concat(_toConsumableArray(chainState))));
    case 'REMOVE_NOTIFICATION':
      {
        return Object.assign(Object.assign({}, state), _defineProperty({}, chainId, chainState.filter(function (notification) {
          return notification.id !== action.notificationId;
        })));
      }
  }
}